export default __webpack_public_path__ + "static/media/Kel'Avashk Robes.4ca92044.jpg";